module.exports = __webpack_public_path__ + "img/growththumb.180ff15f.gif";